import React, {lazy, useEffect} from "react";
import {Route, Switch} from "react-router-dom";
import Portada from "../Portada";
import AADService from '../Azure/AADService';
import MapPlantas from "../MapPlantas";
import { BreadCrumb } from 'primereact/breadcrumb';
import { useTranslation,withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import * as proyectAction from "../../store/actions/proyectAction";
import Configuracion from "../Configuacion/Configuracion";
import { rolAcceso, rutaConfig, rutaAddUser, rutaPlantas, rutaMapa, rutaIndex } from "../../Config/const";
import NoAcceso from "../NoAcceso";
import AddUser from "../AddUser";

const Planta = lazy(() => import('../Planta'));
const AzureADService = new AADService();


const Routes = ({reloadLayout,restoreBoard,refreshInterval,layoutColorDark,staticMenuInactive,layoutMode,cantDias,global}) => {
    //console.log("Route")
    const { t } =useTranslation();
    let role=null;
    if(global){
        if(global.user){
            role=global.user.roles
        }
    }
    useEffect(() => {
        //first();
        /*console.log(AzureADService)
        console.log(AzureADService.getToken())
        console.log(AzureADService.getRoles())
        console.log(AzureADService.AADServiceAuthContext())*/
        if(AzureADService.getToken()===null){
            AzureADService.acquireToken();
        }
    });
    
    const items =()=>{
        //console.log(global)
        let respuesta=[];
        if(global.breadCrumb!==undefined&&global.breadCrumb!=={}){
            if(global.breadCrumb.length>1){
                //console.log(global.breadCrumb)
                global.breadCrumb.forEach(function(elemento, index){
                    respuesta.push(elemento)
                })
            }else{
                respuesta.push(global.breadCrumb);
            }
        }
        return(respuesta)  
    } 

    const home = { icon: 'pi pi-home', url: rutaIndex }
    const plantas=()=>{
        if(global.plantas!==null){
            return(
                global.plantas.map((marcador, index)=>(
                    <Route exact path={rutaPlantas+index} key={index} render={props =>
                        <Planta {...props} 
                            layoutColorDark={layoutColorDark} 
                            reloadLayout={reloadLayout} 
                            restoreBoard={restoreBoard} 
                            refreshInterval={refreshInterval}
                            staticMenuInactive={staticMenuInactive}
                            layoutMode={layoutMode}
                            index={index}
                            cantDias={cantDias}
                            breadCrumbLabel={(marcador.nombre)}
                            breadCrumbUrl={rutaPlantas+index}
                        />
                    }/>               
                ))
            )
        }
    }

    const restringido=()=>{
        return(            
            <Route exact path={rutaConfig} render={props => 
                (role===rolAcceso)?
                (<Configuracion {...props} 
                    breadCrumbLabel={t("config")}
                    breadCrumbUrl={rutaConfig}
                />):
                (<NoAcceso {...props} 
                    breadCrumbLabel={t("config")}
                    breadCrumbUrl={rutaConfig}/>)
                }
            /> 
        )
    }

    const addUser=()=>{
        return(            
            <Route exact path={rutaAddUser} render={props => 
                (role===rolAcceso)?
                (<AddUser {...props} 
                    breadCrumbLabel={[t("config"),t("AddUser")]}
                    breadCrumbUrl={[rutaConfig,rutaAddUser]}
                />):
                (<NoAcceso {...props} 
                    breadCrumbLabel={t("AddUser")}
                    breadCrumbUrl={rutaAddUser}/>)
                }
            /> 
        )
    }

    return(
        <div className="layout-main">
            <div>
                <BreadCrumb className={"breadCrumb"} model={items()} home={home} />
            </div>

            <Switch>
                {plantas()}
                <Route exact path={rutaMapa} render={props => 
                    <MapPlantas {...props} 
                        breadCrumbLabel={t("Map")}
                        breadCrumbUrl={rutaMapa}
                    />}
                /> 
                {restringido()}
                {addUser()}
                <Route path={rutaIndex} render={props => <Portada {...props} />}/>
                
            </Switch>
        </div>
    );
}

const mapStateToProps = (rootReducer) => {
    return {global: rootReducer.proyect};
};

export default connect(mapStateToProps, proyectAction)(withTranslation ("translations") (Routes));
